import React from 'react';
import { PollLiveEditor } from '../live/PollLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function PollBuilder(props: StudioLiveEditorProps) {
  return <PollLiveEditor {...props} />;
}
